import { RateJson } from '../../types/models';
import { CamionNetBaseApiClient } from '../base-client';

/**
 * Rates API Types
 */
export type GetClientRatesResponse = RateJson[];

/**
 * Rates API Endpoints
 */
export class RatesApi extends CamionNetBaseApiClient {
  /**
   * Get rates for a specific client
   */
  async getClientRates(clientId: number): Promise<GetClientRatesResponse> {
    return this.request<GetClientRatesResponse>(`/api2/rates/clients/${clientId}`);
  }
}
